<template>
  <div class="post-like-action">
    <div class="icon">
      <button class="button basic" @click="onClickLikeButton">
        <AppIcon :name="likeIcon" />
      </button>
    </div>
    <div class="text" v-if="post.totalLikes">
      {{ post.totalLikes }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import AppIcon from '@/app/components/app-icon';

export default defineComponent({
  name: 'PostLikeAction',

  /**
   * 属性
   */
  props: {
    post: {
      type: Object,
    },
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
    }),

    likeIcon() {
      return this.post.liked ? 'favorite' : 'favorite_border';
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapActions({
      createUserLikePost: 'like/create/createUserLikePost',
      deleteUserlikePost: 'like/destroy/deleteUserLikePost',
      pushMessage: 'notification/pushMessage',
    }),

    onClickLikeButton() {
      if (!this.isLoggedIn) {
        return this.pushMessage({ content: '请先登录' });
      }

      if (this.post.liked) {
        this.deleteUserlikePost({ postId: this.post.id });
      } else {
        this.createUserLikePost({ postId: this.post.id });
      }
    },
  },

  /**
   * 使用组件
   */
  components: {
    AppIcon,
  },
});
</script>

<style scoped>
@import './styles/post-like-action.css';
</style>
